import './ccf-align-left-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAlignLeftIconProps extends SvgIconProps {}
/**
 * Component used to display align left Icon
 * @param props - CcfAlignLeftIconProps
 * @example - <CcfAlignLeftIcon />
 * @returns SVG of align left
 */
export function CcfAlignLeftIcon(props: CcfAlignLeftIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="align-left_icon" data-name="Align Left" transform="translate(3.702 3.702)">
          <path d="M15,19H3a1,1,0,0,0,0,2H15a1,1,0,0,0,0-2Zm6-8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0,4H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z" transform="translate(-2 -11)"/>
        </g>
    </SvgIcon>
  );
}

export default CcfAlignLeftIcon;
